import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { scheduleScrollToHashSection } from "../utils/scrollToHashSection";

/** Resets scroll on route changes, or scrolls to a hash target when the URL includes a fragment. */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      return scheduleScrollToHashSection(hash);
    }

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
